import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { Config } from '../../config';
import { BaseComponent } from '@shared/components/base.component';

@Component({
  selector: 'app-ph-avatar',
  templateUrl: './ph-avatar.component.html',
  styleUrls: ['./ph-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhAvatarComponent extends BaseComponent implements OnChanges {
  @Input() size: string = Config.DEFAULT_AVATAR_SIZE;
  @Input() username: string = this.translate.instant('GLOBAL.anonymous');
  @Input() src: string = null;
  @Input() isWhite: boolean;
  currentSrc: string = null;
  loading: boolean = false;

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnChanges(src: any) {
    if (src.src) {
      this.loading = true;
      this.currentSrc = 'empty';
      // Timeout - hack for task https://github.com/HaithemMosbahi/ngx-avatar/issues/69
      // If this bug is fixed, pls correct this function
      setTimeout(() => {
        this.currentSrc = src.src ? src.src.currentValue : '';
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      }, 100);
    }
  }
}
